exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sk-spinner-pulse {\r\n    position: relative;\r\n    top: 50%;\r\n    width: 40px;\r\n    height: 40px;\r\n    margin: auto;\r\n    border-radius: 100%;\r\n    -webkit-animation: sk-pulseScaleOut 1s infinite ease-in-out;\r\n    animation: sk-pulseScaleOut 1s infinite ease-in-out;\r\n}\r\n\r\n@-webkit-keyframes sk-pulseScaleOut {\r\n    0% {\r\n        -webkit-transform: scale(0);\r\n        transform: scale(0);\r\n    }\r\n    100% {\r\n        -webkit-transform: scale(1);\r\n        transform: scale(1);\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n@keyframes sk-pulseScaleOut {\r\n    0% {\r\n        -webkit-transform: scale(0);\r\n        transform: scale(0);\r\n    }\r\n    100% {\r\n        -webkit-transform: scale(1);\r\n        transform: scale(1);\r\n        opacity: 0;\r\n    }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Git_new/IVMS_PRO/web/src/app/spinner/spinkit-css/sk-spinner-pulse.css
// module id = ../../../../../src/app/spinner/spinkit-css/sk-spinner-pulse.css
// module chunks = main